import Vue from 'vue';
//@ts-ignore
import PRGLink from 'static-components/src/vue/prg/PRGLink.vue';
var initializePRGLink = function () {
    //@ts-ignore
    var links = document.querySelectorAll('PRGLink, prglink');
    links.forEach(function (item) {
        var html = item.innerHTML;
        new Vue({
            render: function (h) { return h(PRGLink, {
                props: {
                    //@ts-ignore
                    url: item.dataset.url,
                    //@ts-ignore
                    classes: item.dataset.classes,
                    html: html,
                    //@ts-ignore
                    linkTargetBlank: typeof item.dataset.linktargetblank !== "undefined" && item.dataset.linktargetblank === "true"
                },
            }); },
        }).$mount(item);
    });
};
export default initializePRGLink;
